<template>
  <v-app :class="classes">
    <v-container
      v-if="preloading"
      fluid
      class="mt-10 pt-10"
    >
      <MyLoader />
    </v-container>
    <router-view v-else />
  </v-app>
</template>

<script>
import oldUrls from './oldUrls.json'
import sharedMethods from './methods/sharedMethods'
import api from './store/api.js'
import { createHelpers } from 'vuex-map-fields'
import state from './store/state.js'
import sharedComputed from '@/methods/sharedComputed'
import FontFaceObserver from 'fontfaceobserver'
import MyLoader from '@/components/App/_MyLoader.vue'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'App',
  components: { MyLoader },

  data() {
    return {
      preloading: true,
    }
  },

  created() {
    this.loadLocalFavorites()
    this.tryOldUrlRedirect()

    setTimeout(() => {
      this.userJustEntered = false
    }, 3000)

    this.setGoogleScriptTags()

    const urlParams = new URLSearchParams(window.location.search)
    if (
      urlParams.get('showArticleOnly') &&
      parseInt(urlParams.get('showArticleOnly')) === 1
    ) {
      this.showArticleOnly = true
    }

    this.openTs = +new Date()
    this.lang = this.getLangFromUrl(this.$route.path) || 'en'
    if (!this.languages.includes(this.lang)) {
      this.lang = 'en'
    }
    this.$i18n.locale = this.lang
    this.isHomepage = this.homepage

    if (this.$route.name === 'calendar') {
      this.preloading = false
      return
    } else {
      // Is site app, so set background image
      // console.log('apply background prop correct')
      // document.documentElement.style.setProperty('--background-prop', getComputedStyle(document.documentElement).getPropertyValue('--background-prop-img'))
    }

    this.setHtmlTagLang()

    // For SEO and fast initial load
    // Set hot images
    // Set items for the list
    this.getAndSetObjectsOnHomePageWhenJustCreated()

    // this.$store.dispatch('getHotObjects').then((response) => {
    // this.preloadSelectedObjectInitialImages()
    // })
    this.getBookingFormInfoFromUrl()
    // First priority stuff

    api.getSiteMenu().then((response) => {
      if (response.items) {
        this.$store.dispatch('setVal', {
          k: 'menuResponse',
          v: response.items.filter((item) => item.hideTemp !== '1'),
        })
        this.setPagesById(response.items)
        // First priority stuff

        this.observeFontLoad()

        // Delay load so objects will beloaded before
        setTimeout(() => {
          // api.getTemplateVars().then((response) => {
          //   this.setTemplateVarsByLang(response.items)
          // })

          // Second priority stuff
          this.$store.dispatch('getFeatures')
          api.getBookingExtras().then((response) => {
            this.bookingExtras = response.items
          })
          api.getObjectRegions().then((response) => {
            this.objectRegions = response.items
          })
        }, 500)
      }
    })
    window.addEventListener('resize', this.resizeHandler)
    window.addEventListener('scroll', this.scrollHandler)
    this.updateWindowWidth()
  },

  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
    window.removeEventListener('scroll', this.scrollHandler)
  },

  watch: {
    homepage() {
      this.isHomepage = this.homepage
    },

    routeFullPath() {
      const langBefore = this.lang
      const newLang = this.getLangFromUrl(this.$route.path)
      if (newLang && newLang !== langBefore && langBefore) {
        this.lang = newLang
        this.$i18n.locale = newLang
      }
      this.getBookingFormInfoFromUrl()
    },

    lang() {
      this.setHtmlTagLang()
    },
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,

    classes() {
      return [
        this.isDesktopView ? 'desktop-view' : 'mobile-view',
        this.showSeeBackground &&
        ['homewlang', 'home', 'search'].includes(this.$route.name) &&
        !this.preloading
          ? 'app-container-background'
          : '',
        this.detailedSearch ? 'detailed-search-open' : '',
      ]
    },

    showSeeBackground() {
      return this.$route.name !== 'calendar' && this.isMobileView
    },

    menuResponse() {
      return this.$store.getters.menuResponse
    },
  },

  mounted() {
    this.fixFacebookHeight()
    document.addEventListener('dblclick', function (event) {
      event.preventDefault()
    })
  },

  methods: {
    ...sharedMethods,

    getAndSetObjectsOnHomePageWhenJustCreated() {
      if (['homewlang', 'home'].includes(this.$route.name)) {
        this.progressSearching = true
      }
      api.getCacheFor('objects').then((result) => {
        const sorted = [...result.items]
          .filter((obj) => obj.visible)
          .sort((a, b) =>
            parseInt(a.sortOrder) > parseInt(b.sortOrder) ? 1 : -1
          )
          .map((object) => {
            object.objectImages = object.objectImages.sort((a, b) => {
              return parseInt(a.sortOrder) > parseInt(b.sortOrder) ? 1 : -1
            })
            return object
          })

        this.$store.state.objectsCache = [...sorted]

        // Set hot objects
        this.$store.state.hotImages = [...sorted].filter(
          (object) => object.is_hot
        )

        // Set result for home page
        if (['homewlang', 'home'].includes(this.$route.name)) {
          // Set list result
          this.$store.state.searchResult = [...sorted].slice(0, 12)
          this.$store.state.searchTotal = this.$store.state.objectsCache.filter(
            (obj) => obj.is_front
          ).length

          // Remove loader
          this.progressSearching = false

          // Now get dynamically from api including map items (map shown no mobile home)
          this.$store.dispatch('findObjects').then()
        }
      })
    },

    observeFontLoad() {
      const observer = new FontFaceObserver('Material Design Icons')

      observer
        .load()
        .then(() => {
          this.preloading = false
        })
        .catch(() => {
          console.error('Font could not be loaded')
        })
    },

    setGoogleScriptTags() {
      // Load e-mai form recaptcha later
      setTimeout(() => {
        const script = document.createElement('script')
        script.src = 'https://www.google.com/recaptcha/api.js'
        script.async = true
        script.defer = true
        document.head.appendChild(script)
      }, 20000)

      let mapDelay =
        this.$route.name === 'object'
          ? 3000
          : ['homewlang', 'home'].includes(this.$route.name)
            ? 5000
            : this.$route.name === 'article'
              ? 3000
              : 0

      if (this.isMobileView && mapDelay > 1000) {
        mapDelay = 1000
      }

      // Load MAPS later
      setTimeout(() => {
        const script = document.createElement('script')
        // AK gmail account
        // script.src = 'https://maps.googleapis.com/maps/api/js?sensor=false&key=AIzaSyAHHRUpF8QIFuwb8zDGYFpcYL-a4XKvAC0&callback=initMap'
        // kop...aa.com acc
        script.src =
          'https://maps.googleapis.com/maps/api/js?sensor=false&key=AIzaSyBPMWNU5vKZ1xEm9K04BkagJytDnLubCOw&callback=initMap'
        script.async = true
        script.defer = true
        document.head.appendChild(script)
        setTimeout(() => {
          this.$store.state.googleMapsLoaded = true
        }, 2000)
      }, mapDelay)
    },

    setHtmlTagLang() {
      const htmlElement = document.documentElement
      htmlElement.setAttribute('lang', this.lang)
    },

    // Fix breakpoints not working in Facebook Mobile browser
    fixFacebookHeight() {
      this.$vuetify.clientHeight--
      this.$nextTick(() => {
        this.$vuetify.clientHeight++
      })
      setTimeout(() => {
        this.fixFacebookHeight()
      }, 500)
    },

    scrollHandler() {
      const currentScrollTop = window.scrollY
      this.scrolledTop = currentScrollTop

      // Hide/show mobile header based on scroll direction
      if (this.isMobileView) {
        const scrollThreshold = 100 // Start hiding after scrolling down 100px
        const scrollDelta = 10 // Minimum scroll delta to trigger hide/show

        if (currentScrollTop > this.lastScrollTop && currentScrollTop > scrollThreshold) {
          // Scrolling down and past threshold - hide header
          if (Math.abs(currentScrollTop - this.lastScrollTop) > scrollDelta) {
            this.hideMobileHeader = true
          }
        } else if (currentScrollTop < this.lastScrollTop) {
          // Scrolling up - show header
          if (Math.abs(currentScrollTop - this.lastScrollTop) > scrollDelta) {
            this.hideMobileHeader = false
          }
        }

        this.lastScrollTop = currentScrollTop
      }
    },

    updateWindowWidth() {
      // Resize handler not working as expected on mobile, fb?
      if (window.innerWidth !== this.windowWidth) {
        this.windowWidth = window.innerWidth
      }
      setTimeout(() => {
        this.updateWindowWidth()
      }, 250)
    },

    resizeHandler() {
      this.windowHeight = window.innerHeight
      this.windowWidth = window.innerWidth
    },

    tryOldUrlRedirect() {
      const pathName = window.location.pathname
      if (!pathName) {
        return
      }
      const pathParts = pathName.split('/')
      if (!pathParts || pathParts.length < 2) {
        return
      }
      let key = pathParts[1] + '/' + pathParts[2]
      const newLangs = {
        eng: 'en',
        fin: 'fi',
        est: 'et',
        // rus: 'ru',
        esp: 'es',
      }
      const objectLinkWithoutLang = oldUrls['eng/' + pathParts[1]]
      if (oldUrls[key] || objectLinkWithoutLang) {
        if (objectLinkWithoutLang) {
          key = 'eng/' + pathParts[1]
        }
        api.getOneItemWithQuery('objects', oldUrls[key], []).then((object) => {
          this.$router.push({
            path: this.objectLinkWithLang(
              object,
              objectLinkWithoutLang ? 'en' : newLangs[pathParts[1]]
            ),
          })
        })
      }
    },

    loadLocalFavorites() {
      const localFavorites = window.localStorage.getItem('my_favorites')
      try {
        if (localFavorites && JSON.parse(localFavorites)) {
          this.favorites = JSON.parse(localFavorites)
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('local-storage-my-favorites', err)
      }
    },

    setBannersByLang(banners) {
      const bannersByLang = {}
      banners.forEach((banner) => {
        const lang =
          (banner.languageRef && banner.languageRef.languageCode) || 'undefined'
        if (!bannersByLang[lang]) {
          bannersByLang[lang] = []
        }
        bannersByLang[lang].push(banner)
      })
      this.$store.dispatch('setVal', {
        k: 'bannersByLang',
        v: bannersByLang,
      })
    },

    setGalleriesByArticleId(galleries) {
      const byArticle = {}
      galleries.forEach((gallery) => {
        const articleId = gallery.showForArticle
          ? gallery.showForArticle._id
          : 'none'
        if (!byArticle[articleId]) {
          byArticle[articleId] = []
        }
        byArticle[articleId].push(gallery)
      })
      this.$store.dispatch('setVal', {
        k: 'galleriesByArticleId',
        v: byArticle,
      })
    },

    setPagesById(pages) {
      const pagesById = {}
      const pagesBySeoName = {}
      pages.forEach((page) => {
        pagesById[page._id] = page
        this.languages.forEach((lang) => {
          if (page['seoName_' + lang]) {
            pagesBySeoName[page['seoName_' + lang]] = page
          }
        })
      })
      this.$store.dispatch('setVal', {
        k: 'pagesById',
        v: pagesById,
      })
      this.$store.dispatch('setVal', {
        k: 'pagesBySeoName',
        v: pagesBySeoName,
      })
    },

    // setTemplateVarsByLang(vars) {
    //   const templateVarsByLang = {}
    //   ;['et', 'en', 'fi', 'es', 'ru'].forEach((lang) => {
    //     templateVarsByLang[lang] = {}
    //     vars.forEach((prop) => {
    //       templateVarsByLang[lang][prop.propertyName] =
    //         prop['translation_' + lang]
    //     })
    //   })
    //   this.$store.dispatch('setVal', {
    //     k: 'templateVarsByLang',
    //     v: templateVarsByLang,
    //   })
    // },
  },
}
</script>

<style src="./components/App/App.scss" lang="scss" />
<style src="./styles/Layout.scss" lang="scss" />
<style src="./styles/Header.scss" lang="scss" />
<style src="./styles/HeaderMobile.scss" lang="scss" />
<style src="./styles/List.scss" lang="scss" />
<style src="./styles/ListTopFilters.scss" lang="scss" />
<style src="./styles/ListObject.scss" lang="scss" />
<style src="./styles/ObjectInfo.scss" lang="scss" />
<style src="./styles/ObjectView.scss" lang="scss" />
<style src="./styles/Form.scss" lang="scss" />
<style src="./styles/SearchForm.scss" lang="scss" />
<style src="./styles/VuetifyOverwrites.scss" lang="scss" />
<style src="./styles/Tooltip.scss" lang="scss" />
<style src="./styles/Ported/PortedGeneral.scss" lang="scss" />
<style src="./styles/Ported/PortedCalendar.scss" lang="scss" />
